<template>
    <div v-if="!formSubmitted">
        <VeeForm  :validation-schema="contactValidationSchema" v-slot="{ handleSubmit, errors }" as="div" class="col-12">
            <form class="contact-form" @submit="handleSubmit($event, onSubmit)" method="post" :action="this.baseUrl + '/enter-reg-submit'" ref="rcontactForm">
                <div class="row gx-3 gy-2 w-100">
                    <div class="col-6 pt-2 reg-wrapper">
                        <Field name="human" type="hidden" value="" />
                        <Field name="stamp" type="hidden" :value="timestamp"/>
                        <Popper :content="errors?.name" arrow placement="top" class="w-100 m-0 border-0" :show="errors?.name ? true : false">
                            <Field name="name" type="text" class="form-control" placeholder="Name" />
                        </Popper>
                    </div>
                    <div class="col-6 pt-2">
                        <Popper :content="errors?.email" arrow placement="top" class="w-100 m-0 border-0" :show="errors?.email ? true : false">
                            <Field name="email" type="email" class="form-control" placeholder="Email" />
                        </Popper>
                    </div>
                    <div class="col-6 pt-2">
                        <Popper :content="errors?.telephone" arrow placement="top" class="w-100 m-0 border-0" :show="errors?.telephone ? true : false">
                            <Field name="telephone" type="text" class="form-control" placeholder="Telephone" />
                        </Popper>
                    </div>
                    <div class="col-6 pt-2">
                        <Popper :content="errors?.reference" arrow placement="top" class="w-100 m-0 border-0" :show="errors?.reference ? true : false">
                            <Field name="reference" class="form-control" placeholder="Order Reference" type="text"/>
                        </Popper>
                    </div>
                    <div class="col-12 pt-2">
                        <Popper :content="errors?.message" arrow placement="top" class="w-100 m-0 border-0" :show="errors?.message ? true : false">
                            <Field name="message" as="textarea" class="form-control" placeholder="Message" />
                        </Popper>
                    </div>
                    <div class="col-12 pt-2">
                        <button class="btn btn-primary mt-2 d-block mx-auto" type="submit">
                            Submit message
                        </button>
                        <div v-show="invalidResponse" class="error-msg">Recaptcha is invalid</div>
                    </div>
                </div>
            </form>
            <br>
        </VeeForm>
    </div>
    <div v-else>
        <h2>Your message has been sent <i class="fas fa-circle-check text-primary ps-2 fs-4"></i></h2>
        <p>If your message requires a response, we will get back to you within 24 hours.</p>
    </div>
</template>

<script>
    import { Form as VeeForm, Field } from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: ['timestamp'],
        components: {
            VeeForm,
            Field
        },
        data() {
            const contactValidationSchema = yup.object({
                'name': yup.string().required('Name is a required field'),
                'email': yup.string().email().required('Email is a required field'),
                'telephone': yup.string().required('Telephone is a required field'),
                'reference': yup.string().matches('^[a-zA-Z0-9_.-]*$', {message: 'Reference is invalid'}),
                'message': yup.string().required('Message is a required field')
            });

            return {
                contactValidationSchema,
                formSubmitted: false,
                response: false,
                invalidResponse: false
            }
        },
        mounted() {

        },
        methods: {
            async onSubmit(values) {
                // (optional) Wait until recaptcha has been loaded.
                await this.$recaptchaLoaded();

                // Execute reCAPTCHA with action "submit".
                this.response = await this.$recaptcha('submit');

                if (!this.response) {
                    this.invalidResponse = true;
                } else {
                    this.emitter.emit('isLoading', true);

                    var formData = new FormData();

                    _.forEach(values, function(value, index) {
                        formData.append(index, value);
                    });

                    formData.append('g-recaptcha-response', this.response);

                    const response = await axios.post('/ajax/contact_us', formData);

                    if(response.data.send == true)
                    {
                        this.emitter.emit('isLoading', false);
                        this.formSubmitted = true;
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>